import { getEditedQuotedLineSplit, quotedMoney, withQuotedCostSplit, type QuotedCostLine } from "@workspace/api-zod/quote-cost-split";

export type QuotedPriceDraft = QuotedCostLine & { _splitBasis?: QuotedCostLine };

/** Zero remains a valid price, but clearing/retyping must retain the evidence
 * needed to restore proportions. The basis is transient and never persisted. */
export function applyQuotedPriceEdit<T extends QuotedPriceDraft>(previous: T, next: T) {
  const basis = previous._splitBasis ?? withQuotedCostSplit(previous);
  const split = getEditedQuotedLineSplit({
    ...next,
    labourCost: basis.labourCost,
    materialCost: basis.materialCost,
    plantCost: basis.plantCost,
  }, basis);
  const target = quotedMoney((Number(next.quantity) || 0) * (Number(next.unitCost) || 0));
  return {
    ...next,
    labourCost: String(split.labourCost),
    materialCost: String(split.materialCost),
    plantCost: String(split.plantCost),
    _splitBasis: target > 0 ? undefined : basis,
  };
}
